import { Grid } from "@mui/material";
import { CentreAsyncSelectForm, TextInput } from "components";
import { withForm, WrapperProps } from "hoc";
import { FC, useMemo } from "react";

import { UtilitaireModal } from "../UtilitaireModal";
import { salleService } from "services";
import { useQueryClient } from "@tanstack/react-query";
import { SalleResource } from "types/caisse.type";
import { salleConverter, salleSchema } from "./salleUtils";

const Form: FC<WrapperProps> = (props) => {
  return (
    <UtilitaireModal {...props} onClose={props.onBack} title="Gestion de salle">
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <CentreAsyncSelectForm label="Centre *" name="centre" />
        </Grid>
        <Grid item xs={12}>
          <TextInput label="Nom *" name="libelle" />
        </Grid>
      </Grid>
    </UtilitaireModal>
  );
};

export const SalleForm = withForm(Form, salleSchema);

type SalleModalProps = {
  closeModal: () => void;
  value?: SalleResource;
};

export const SalleModal: FC<SalleModalProps> = ({ closeModal, value }) => {
  const query = useQueryClient();

  const onSave = (data: any) => {
    const body = salleConverter.toBody(data);
    if (value?.id) {
      return salleService.update(value.id, body);
    }
    return salleService.create(body);
  };

  const onFinished = () => {
    query.invalidateQueries(["salles"]);
    closeModal();
  };

  const defaultValues = useMemo(() => {
    if (value) {
      return salleConverter.toInput(value);
    }
    return {};
  }, [value]);

  return (
    <SalleForm
      onBack={closeModal}
      onFinished={onFinished}
      onSave={onSave}
      defaultValues={defaultValues}
    />
  );
};
